import { invalidChars } from './constants';

export default function keyCodeValidator(keyCode) {
	return !Object.keys(invalidChars).find(key => invalidChars[key] === keyCode);
}
